export default "__VITE_ASSET__CNGkNlx1__"